import Component from './BadgeLabel.component';

export default Component;
